import ColourPageSection from "components/ColourPageSection";
import { ReactNode } from "react";
import { ASSET_PREFIX } from "utils/constants";

interface IArcadeColourPageSectionProps {
  id?: string;
  colour?: string;
  noPadding?: boolean;
  onClick?: () => void;
  additionalClassName?: string;
  children?: ReactNode;
}

const ArcadeColourPageSection = ({
  id,
  colour = "green",
  noPadding,
  onClick,
  additionalClassName,
  children,
}: IArcadeColourPageSectionProps) => {
  let colourGradient = "#90F6DF70 linear-gradient(#C3FBF170, #6CFADF70)";
  if (colour === "grey") {
    colourGradient = "#FFFFFF80";
  }
  return (
    <div
      id={id}
      className="arcadeColourPageSection fullWidth flexCentered"
      onClick={onClick}
    >
      <ColourPageSection
        colourGradient={colourGradient}
        noPadding={noPadding}
        additionalClassName={additionalClassName}
      >
        {children}
      </ColourPageSection>

      <style jsx>
        {`
          .arcadeColourPageSection {
            background-image: url(${ASSET_PREFIX}/images/token-town/arcade-bricks.svg);
            background-position: initial;
            background-repeat: repeat;
          }
        `}
      </style>
    </div>
  );
};

export default ArcadeColourPageSection;
